(() => {
  const angular = window.angular;
  Controller.$inject = ['$rootScope'];

  angular.module('app').component('multiSelectDropdown', {
    template:'<div style="display: block" class="btn-group multiselect-dropdown" uib-dropdown on-toggle="ctrl.onToggle(open)" auto-close="outsideClick"><button class="btn btn-block btn-default" style="text-align: left" uib-dropdown-toggle ng-disabled="!ctrl.items.length || ctrl.disabled"><span ng-show="ctrl.items.length"><span ng-if="ctrl.selectedItems.length">{{ctrl.selectedItems.length}} <span translate>multiselect_dropdown.selected</span></span> <span ng-if="!ctrl.selectedItems.length" translate class="text-muted">multiselect_dropdown.select</span></span> <span ng-show="!ctrl.items.length" translate>multiselect_dropdown.noElements</span> <span class="fas fa-chevron-down"></span></button><ul class="dropdown-menu paddingT0" uib-dropdown-menu style="max-height: 300px; overflow-y: auto; width: 100%"><li ng-show="!ctrl.items.length" class="marginTB20 text-center"><strong translate>multiselect_dropdown.noElementsFound</strong></li><li class="no-padding" ng-if="ctrl.buttonsEnabled"><div class="padding5"><div class="row row-xs"><div class="col-xs-6"><button ng-click="ctrl.selectAll()" class="btn btn-default btn-xs btn-block"><small class="fas fa-fw fa-check"></small> <small translate>multiselect_dropdown.selectAll</small></button></div><div class="col-xs-6"><button ng-click="ctrl.unSelectAll()" class="btn btn-default btn-xs btn-block"><small class="fas fa-fw fa-times"></small> <small translate>multiselect_dropdown.selectNone</small></button></div></div></div></li><li class="divider marginT0 marginB5"></li><li class="paddingLR5" ng-if="ctrl.searchEnabled"><input class="form-control input-xs" translate-attr="{placeholder: \'buttons.search\'}" ng-model="ctrl.search.name"></li><li class="divider marginTB5" ng-if="ctrl.searchEnabled"></li><li ng-repeat="item in ctrl.visibleItems = (ctrl.items | search:ctrl.search)" class="nowrap" title="{{::item.name}}"><label class="checkbox no-margin paddingLR10 paddingTB5 cursor-pointer" ng-class="{disabled: item.disabled || !item.selected && ctrl.maxItems !== null && ctrl.selectedItems.length >= ctrl.maxItems}"><input type="checkbox" ng-model="item.selected" ng-disabled="item.disabled || !item.selected && ctrl.maxItems !== null && ctrl.selectedItems.length >= ctrl.maxItems" ng-change="ctrl.toggleItem(item)"> <i></i> <span>{{::item.name}}</span></label></li></ul></div>',
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      items: '<',
      selectedItems: '<',
      maxItems: '<',
      onSelect: '&',
      disabled: '<',
      searchEnabled: '<',
      buttonsEnabled: '<',
    },
  });

  function Controller($root) {
    const vm = this;

    vm.$onInit = function () {
      vm.items = vm.items || [];
      vm.selectedItems = vm.selectedItems || [];
      vm.maxItems = typeof vm.maxItems === 'number' ? vm.maxItems : null;
      vm.searchEnabled = typeof vm.searchEnabled === 'boolean' ? vm.searchEnabled : true;
      vm.buttonsEnabled = typeof vm.buttonsEnabled === 'boolean' ? vm.buttonsEnabled : true;

      vm.toggleItem = toggleItem;
      vm.selectAll = selectAll;
      vm.unSelectAll = unSelectAll;

      vm.isOpened = false;
      vm.search = {};

      vm.visibleItems = vm.items;

      vm.onToggle = onToggle;
    };

    vm.$onChanges = function () {
      vm.selectedItems = vm.selectedItems || [];
      vm.selectedItems.forEach((current) => {
        current.selected = true;
      });
    };

    function toggleItem(item) {
      const index = vm.selectedItems.findIndex((current) => current === item);

      if (index === -1) {
        if (vm.maxItems === null || vm.selectedItems.length < vm.maxItems) {
          vm.selectedItems.push(item);
        }
      } else {
        vm.selectedItems.splice(index, 1);
      }
    }

    function selectAll() {
      vm.selectedItems.splice(0, vm.selectedItems.length);
      for (let item of vm.visibleItems) {
        if (item.disabled || (vm.maxItems !== null && vm.selectedItems.length >= vm.maxItems)) {
          continue;
        }
        item.selected = true;
        vm.selectedItems.push(item);
      }
    }

    function unSelectAll() {
      vm.selectedItems.splice(0, vm.selectedItems.length);
      for (let item of vm.visibleItems) {
        item.selected = false;
      }
    }

    function onToggle(open) {
      if (!open) {
        vm.onSelect();
      }
    }
  }
})();
